<template>
  <div class="sound">
    <div class="container">
      <div class="banner">
        <img src="/imgs/01.jpg" alt="" />
      </div>
      <!-- 主容器，分左右，右边长列表 -->
      <div class="i-con">
        <!-- 右侧长列表 -->
        <div class="i-r">
          <!-- 推荐 -->
          <div class="z1-con">
            <!-- 推荐方块 -->
            <span>本站推荐</span>
            <!-- 标题 -->
            <div class="z1-title" @click="goDetails('1')">
              你能否为心爱的主播守住阵地？
            </div>
            <!-- 简介 -->
            <div class="z1-brief" @click="goDetails('1')">
              你有没有发现，你正在被知名App中新添加的直播板块圈粉？既然本来就下载了一个App，再多用一下又何妨？截止于今年6月8日，安卓端中国App+游戏排行榜中，150名是一个分水岭。以YY、映客为代表的纯直播App已经接近前150名，而前150名中，已经有至少有20个知名App带有直播功能（还没有包括QQ、百度贴吧等为纯直播app带量的行为）。
            </div>
          </div>

          <!-- 资讯区块2 -->
          <div class="z2-con">
            <!-- 标题 -->
            <div class="z2-title"><span>最新文章</span><span></span></div>

            <!-- 列表 -->
            <div class="ul">
              <!-- 循环项 -->
              <li
                class="z2-item"
                v-for="(item, index) in ac3"
                :key="index"
                @click="goDays(item.methods, item.id)"
              >
                <img :src="item.img" alt="" />
                <div class="z2-info">
                  <div class="z2-t">{{ item.title }}</div>
                  <div class="z2-time">{{ item.time }}</div>
                </div>
              </li>
            </div>
          </div>
        </div>

        <!-- 左侧长内容 -->
        <div class="i-l">
          <!-- 头部 -->
          <div class="s-header">
            <h2>{{ this.my_title }}</h2>
            <span> <i class="iconfont icon-zuozhe"></i>{{ this.author }}</span>
            <span> <i class="iconfont icon-time"> </i>{{ this.time }} </span>
            <span> <i class="iconfont icon-dianzan"></i> {{ this.sub }}</span>
          </div>

          <!-- 内容 -->
          <div class="s-con">
            <!-- 图片 -->
            <img :src="this.img" alt="" />
            <!-- 文字 -->
            <div class="s-text">
              <p>{{ this.my_p1 }}</p>
              <p>{{ this.my_p2 }}</p>
              <p>{{ this.my_p3 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 获取 id
      myId: this.$route.query.type,
      // 标题
      my_title: "",
      // 段落一
      my_p1: "",
      // 段落2
      my_p2: "",
      my_p3: "",
      author: "",
      time: "",
    };
  },
  mounted() {
    this.init();
    document.title = "谜语网络";
  },
  methods: {
    init() {
      this.axios.get("/mock/info.json").then((res) => {
        var vl = res.data;
        var date = vl.find((vl) => vl.id == this.myId);
        console.log(date);
        // console.log(date)
        // 标题
        this.my_title = date.title;
        // 作者
        this.author = date.author;
        // 歌词
        this.concise = date.concise;
        // 图片路径
        this.img = date.img;
        // 文章 1
        this.my_p1 = date.p1;
        // 文章 2
        this.my_p2 = date.p2;
        this.my_p3 = date.p3;
        this.time = date.time;
        this.sub = date.sub;
        this.ac3 = vl.slice(1, 7);
      });
    },
    // 跳转功能
    goDays(methodsWords, id) {
      this[methodsWords](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
      location.reload();
    },
    // 收费逻辑
    gopay() {
      // console.log('1')

      if (this.state == 0) {
        // this.$router.push("/pay");
        this.showModal = true;
        console.log(this.showModal);
      }
      // 未登录
      if (this.state !== 0) {
        alert("资讯每条3元，点击确定注册购买");
        this.$router.push({ path: "/register", query: { k: 1 } });
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.sound {
  padding-top: 60px;
  box-sizing: border-box;
  .container {
    .banner {
      width: 100%;
      height: 154px;
      margin: 30px 0;
      margin-bottom: 70px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 主容器1
    .i-con {
      display: flex;
      justify-content: space-between;
      width: 100%;
      // height: 3000px;
      // background-color: pink;
      // margin: 160px auto 60px;
      // 左侧
      .i-l {
        padding: 20px;
        width: 70%;
        height: 100%;
        background-color: #fff;
        box-sizing: border-box;

        // 头部
        .s-header {
          width: 100%;
          height: 100px;
          background-color: #fff;
          text-align: center;
          h2 {
            margin-bottom: 30px;
          }
          span {
            font-size: 14px;
            margin: 0 15px;
            i {
              font-weight: 400;
              margin-right: 5px;
            }
          }
        }
        // 文章容器
        .s-con {
          // 图片
          img {
            width: 100%;
            height: 400px;
            margin: 30px auto;
            // background-color: pink;
          }
          // 文章
          .s-text {
            width: 100%;
            text-align: left;
            padding: 20px;
            box-sizing: border-box;
            p {
              margin: 20px auto;
              font-size: 14px;
              line-height: 70px;
            }
          }
        }
      }

      // 右侧
      .i-r {
        width: 30%;
        height: 100%;
        // background-color: #c60023;
        box-sizing: border-box;
        margin-right: 30px;

        // 推荐区块
        .z1-con {
          width: 100%;
          height: 190px;
          background-color: #fff;
          padding-left: 10px;
          box-sizing: border-box;
          span {
            border: none;
            border-radius: 0;
            color: #fff;
            display: inline-block;
            font-size: 14px;
            padding: 5px 15px;
            width: auto;
            margin: -1px 0 0 15px;
            z-index: 2;
            background-color: #00bfb0;
          }
          // 标题
          .z1-title {
            font-size: 24px;
            font-weight: 400;
            margin-bottom: 10px;
            color: #00bfb0;
            margin-top: 20px;
            font-weight: bold;
          }
          // 简介
          .z1-brief {
            font-size: 14px;
            line-height: 1.7;
            color: #999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;
            overflow: hidden;
          }
        }

        // 最新文章区块
        .z2-con {
          background-color: #fff;
          border: 1px solid #eaeaea;
          // margin-bottom: 12px;
          padding: 15px;
          line-height: 1.4;
          margin: 20px auto;
          // 标题
          .z2-title {
            background-color: #fbfbfb;
            border-bottom: 1px solid #eaeaea;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            color: #333;
            font-size: 14px;
            position: relative;
            padding: 9px 15px;
            position: relative;
            top: -15px;
            left: -15px;
            width: 100%;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
          }

          // 循环项
          .z2-item {
            display: flex;
            margin: 15px auto;
            align-items: center;
            // 图片
            img {
              width: 80px;
              height: 80px;
              background-color: #c60023;
              margin-right: 15px;
            }
            // info
            .z2-info {
              width: 70%;
              .z2-t {
                font-size: 14px;
                color: #333;
                font-weight: 400;
              }
              .z2-time {
                font-size: 13px;
                margin-top: 4px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }
}
</style>
